<template>
  <transition @enter="velocityEnter" @leave="velocityLeave" :css="false">
    <slot></slot>
  </transition>
</template>

<script>
import Velocity from 'velocity-animate'

export default {
  name: 'cc-category-velocity-anim',
  props: {
    display: { type: String, default: 'Block' },
    enter: { type: String },
    leave: { type: String }
  },
  methods: {
    velocityEnter(el, done) {
      Velocity(el, this.enter, {
        display: this.display,
        easing: 'ease-in-out',
        duration: 300,
        complete: done
      })
    },
    velocityLeave(el, done) {
      Velocity(el, this.leave, {
        easing: 'ease-in-out',
        duration: 300,
        complete: done
      })
    }
  }
}
</script>
